import { useQuery } from '@tanstack/react-query';
import type { AgentApiJobChangeProcessBoardsIndex } from '@/types/serializers';
import { fetchJson } from '@/utils/apiFetch';

export default function useFetchJobChangeProcessBoards() {
  return useQuery({
    queryKey: ['jobChangeProcessBoards'],
    queryFn: async () => {
      const data = await fetchJson<AgentApiJobChangeProcessBoardsIndex>(
        `/agent/api/job_change_process_boards.json`
      );

      return data;
    },
  });
}
